// extracted by mini-css-extract-plugin
export default {"fullWidth":"ao-z","image":"bo-z","lazyLoadPicture":"co-z","lazyLoadSpinner":"do-z","lazyLoadSpin":"eo-z","lazyLoadImage":"fo-z","hasStyledAspectRatio":"go-z"};